import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { ONBOARDING_PALETTE } from '../onboarding-palette';
import type { PanelCardState } from './panel-state';

/**
 * A card of the side panel. The mock-up rings the current card with a shadow;
 * the app draws no shadows, so the ring is the dark border alone.
 */
export const PanelCard = ({ state, children }: { state: PanelCardState; children: ReactNode }) => (
  <Box
    data-state={state}
    bg={state === 'upcoming' ? ONBOARDING_PALETTE.upcomingCard : 'white'}
    borderWidth="1px"
    borderStyle={state === 'upcoming' ? 'dashed' : 'solid'}
    borderColor={
      state === 'current'
        ? 'primary.900'
        : state === 'upcoming'
          ? ONBOARDING_PALETTE.upcomingCardBorder
          : 'white'
    }
    borderRadius="20px"
    p="16px"
    transition="background-color .2s, border-color .2s"
  >
    {children}
  </Box>
);
